import axios from 'axios'
const { url } = window.__REACT_WORDPRESS__.routing

const postGravityForm = async ({ formId, formData }) => {
  try {
    // Construye la URL del endpoint incluyendo el ID del formulario
    const urlPost = `${url}/wp-json/customgf/v2/forms/${formId}/submissions`

    // Hace la solicitud POST con axios, enviando los datos del formulario en el cuerpo
    const { status } = await axios.post(urlPost, formData, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        trapo: 'dd',
      },
    })

    return status === 200
  } catch (error) {
    return false
  }
}

export default postGravityForm
